import { gateway } from "../../../gateway";

export const getContacts = async (token, companyId) => {
  try {
    const response = await gateway.get("/messages/contacts", {
      params: { pageSize: "9999", page: "1" },
      headers: {
        Authorization: `${token}`,
        ...(companyId ? { "x-company-id": String(companyId) } : {}),
      },
    });
    return response.data.data;
  } catch (error) {
    console.error("Error in getContacts:", error);
    throw error;
  }
};
